import { render, staticRenderFns } from "./SwiftTokenForm.vue?vue&type=template&id=b2a8b6f4&scoped=true"
import script from "./SwiftTokenForm.vue?vue&type=script&lang=js"
export * from "./SwiftTokenForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a8b6f4",
  null
  
)

export default component.exports